import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import NotFound from "../NotFound";
import Loading from "../Loading";
import { guiSet, addUrlQuery } from "../../actions/uiActions";
import DzeramaUdensSatecesBaseinsInfo from "./DzeramaUdensSatecesBaseinsInfo";
import DzeramaUdensSatecesBaseinsAktualaSituacija from './DzeramaUdensSatecesBaseinsAktualaSituacija';
import DzeramaUdensSatecesBaseinsVisparigaisRaksturojums from './DzeramaUdensSatecesBaseinsVisparigaisRaksturojums';
import DzeramaUdensSatecesBaseinsRiskaNovertejums from './DzeramaUdensSatecesBaseinsRiskaNovertejums';
import DzeramaUdensSatecesBaseinsAizsargjoslas from './DzeramaUdensSatecesBaseinsAizsargjoslas';
import DzeramaUdensSatecesBaseinsKopsavilkums from './DzeramaUdensSatecesBaseinsKopsavilkums';
import { Style } from 'ol/style.js'
import { dzeramaUdensSatecesBaseinsActions } from '../../actions/dzeramaUdensSatecesBaseiniActions';
import SplitterLayout from 'react-splitter-layout';

import IzraktenisMap from '../karte/IzraktenisMap';
import * as maputils from '../karte/maputils';

export { getNovertejumsColor } from './riskaNovertejumsUtils';

const mapBaseColor = '#FFD700';
const mapRiskuObjektiBaseColor = '#00ffff';
const mapRiskuObjektiSelectedColor = '#00ff80';
const mapBaseTranspColor = mapBaseColor + 'cc';

export const baseinsStyle = maputils.getStrokeStyle({
  strokeColor: mapBaseTranspColor,
  strokeWidth: 4
})

export const baseinsBuferStyle = maputils.getStrokeStyle({
  strokeColor: mapBaseTranspColor,
  strokeWidth: 2,
  lineDash: [5, 5]
})

const dzurUrbumiBlueColor = '#0b87ae'
const dzurUrbumiInnerStyle = maputils.getCircleStyle({
  color: dzurUrbumiBlueColor + 'DD',
  radius: 6,
  strokeWidth: 0,
  strokeColor: '#ffffff00'
})
const dzurUrbumiOuterStyle = maputils.getCircleStyle({
  color: '#ffffff00',
  radius: 6.5,
  strokeColor: '#ff0000',
  strokeWidth: 1.5
})
const dzurUrbumiCenterDot = maputils.getCircleStyle({
  color: '#333333',
  radius: 1.5
})
const dzurUrbumiStyleFunc = () => [
  new Style({ image: dzurUrbumiOuterStyle }),
  new Style({ image: dzurUrbumiInnerStyle }),
  new Style({ image: dzurUrbumiCenterDot })
]
export const dzurUrbumiStyle = {
  default: dzurUrbumiStyleFunc,
  select: {},
  over: {}
}

const cachedRiskaStyles = {};

export const getVectorLayerCfgPamatinfo = (satecesBaseins) => ({
  dzeramaUdensBaseinaGeometrija: {
    title: 'Sateces baseins',
    features: [{
      id: satecesBaseins.id,
      geom: satecesBaseins.sb_geom
    }],
    styles: baseinsStyle,
    zoomTo: satecesBaseins.id,
    zoomToObjectOnlyFirstTime: true,
  },
  dzeramaUdensSatecesBaseinsUrbumi: {
    title: 'Ūdens ieguves vietas',
    features: satecesBaseins.udens_ieguves_vietas,
    styles: dzurUrbumiStyle,
    tooltipFunc: (feat) => `${feat.get('urbumi_id')}: ${feat.get('urb_nr_pirmavota') || ''} ${feat.get('urb_adrese') || ''}`,
  }
})

export const getVectorLayerCfgAktualaSituacija = (satecesBaseins, riskaKategorijas, riskaObjektuKategorijasList) => {
  const riskaKategorijasNosaukums = (kat) => riskaObjektuKategorijasList?.find(k => k.nosaukums === kat)?.nosaukums_display;
  return {
    dzeramaUdensBaseinaBufferZone: {
      title: 'Sateces baseina 100m buferjosla',
      features: satecesBaseins.sb_buffer_geom ? [{
        id: satecesBaseins.id + '_buffer',
        geom: satecesBaseins.sb_buffer_geom
      }] : [],
      styles: baseinsBuferStyle,
    },
    dzur_aktuala_situacija: {
      title: 'Riska objekti',
      features: riskaKategorijas.expandedList || [],
      styles: riskaObjektiByNovertejumsStyles,
      tooltipFunc: feat => `${riskaKategorijasNosaukums(feat.get('kategorija'))}: ${feat.get('nosaukums') || feat.get('adrese') || feat.get('source_identifikators')}`,
      selected: riskaKategorijas.selected
    },
    ...getVectorLayerCfgPamatinfo(satecesBaseins),
  }
}

const riskaObjektiByNovertejumsStyleFunc = (feature) => {
  const sel = feature.get('selected');
  //const novertejums = feature.get('novertejums');
  //const baseColor = getNovertejumsColor(novertejums, true);
  // const key = `${novertejums}_${sel}`;
  const key = sel;
  const strokeColor = sel ? mapRiskuObjektiSelectedColor : mapRiskuObjektiBaseColor;
  const width = sel ? 2.6 : 1.6;
  const radius = sel ? 10 : 8;

  if (!cachedRiskaStyles[key]) {
    cachedRiskaStyles[key] = new Style({
      ...maputils.getFillStrokeProps({
        color: "#ffffff01",
        strokeColor: strokeColor,
        strokeWidth: width
      }),
      image: maputils.getSquareStyle({
        color: "#ffffff01",
        strokeColor: strokeColor,
        strokeWidth: width,
        radius: radius,
      })
    });
  }
  return cachedRiskaStyles[key];
}

export const riskaObjektiByNovertejumsStyles = {
  default: riskaObjektiByNovertejumsStyleFunc,
  select: {},
  over: {}
};

const getTabCfgs = () => {
  return {
    pamatinfo: {
      title: 'Pamatinformācija',
      comp: DzeramaUdensSatecesBaseinsInfo
    },
    visparigais_raksturojums: {
      title: 'Vispārīgais raksturojums',
      comp: DzeramaUdensSatecesBaseinsVisparigaisRaksturojums
    },
    aizsargjoslas: {
      title: 'Aizsargjoslas',
      comp: DzeramaUdensSatecesBaseinsAizsargjoslas
    },
    aktuala_situacija: {
      title: 'Aktuālā situācija',
      comp: DzeramaUdensSatecesBaseinsAktualaSituacija
    },
    riska_novertejums: {
      title: 'Riska novērtējums',
      comp: DzeramaUdensSatecesBaseinsRiskaNovertejums
    },
    kopsavilkums: {
      title: 'Aktuālais kopsavilkums',
      comp: DzeramaUdensSatecesBaseinsKopsavilkums
    },
    // TODO: Pēc nepieciešamības pievienot papildus cilnes
  }
}

class BaseinsTabs extends Component {

  // renderTabNavLinks = (activeTab, isNew) => {
  //   return Object.keys(this.tabCfgs).map(k => (
  //     <NavItem key={k}>
  //       <NavLink className={k === activeTab ? 'active' : ''} disabled={isNew && this.tabCfgs[k].disableWhenNew}>
  //         {this.tabCfgs[k].title}
  //       </NavLink>
  //     </NavItem>
  //   ))
  // }

  renderTabNavLinks = (activeTab, isNew) => {
    const { addUrlQuery } = this.props;
    return Object.keys(this.tabCfgs).map(k => (
      <NavItem key={k}>
        <NavLink
          className={k === activeTab ? 'active' : ''}
          disabled={isNew && this.tabCfgs[k].disableWhenNew}
          onClick={() => {
            if (!isNew || !this.tabCfgs[k].disableWhenNew) {
              addUrlQuery({ tab: k }); // This will cause a rerender with new activeTab
            }
          }}
          href="#"
        >
          {this.tabCfgs[k].title}
        </NavLink>
      </NavItem>
    ))
  }

  renderTabContents = (activeTab, isNew, selectedItem) => {
    const hasGeometry = selectedItem && (
      selectedItem.sb_geom ||
      selectedItem.urbumi_atradnes_geom_id
    );
    return Object.keys(this.tabCfgs).map(k => {
      const Comp = this.tabCfgs[k].comp ? this.tabCfgs[k].comp : NotFound
      return <TabPane key={k} tabId={k}>
        <Comp id={selectedItem?.id} aizsargatiba={selectedItem?.aizsargatiba} hasGeometry={hasGeometry} />
      </TabPane>
    }
    )
  }

  render() {
    const { activeTab, isNew, getTabCfgsFunc } = this.props
    if (!this.tabCfgs) {
      const f = getTabCfgsFunc ? getTabCfgsFunc : getTabCfgs
      this.tabCfgs = f()
    }
    const isArhivets = !!(this.props.selectedItem && this.props.selectedItem.ir_arhivets)
    return <>
      {isArhivets && (
        <div style={{
          backgroundColor: '#6c757d',
          color: '#ffffff',
          padding: '6px 14px',
          borderRadius: '4px',
          marginBottom: '8px',
          fontWeight: 'bold',
          display: 'inline-block'
        }}>
          <i className="fa fa-archive"></i>&nbsp;&nbsp;Arhivēts
        </div>
      )}
      <Nav tabs>
        {this.renderTabNavLinks(activeTab, isNew)}
      </Nav>
      <TabContent activeTab={activeTab}>
        {this.renderTabContents(activeTab, isNew, this.props.selectedItem)}
      </TabContent>
    </>
  }
}

export class BaseinsKartina extends Component {

  mapPaneSizeChange = (w) => {
    this.props.guiSet('dzerama_udens_sateces_baseini_saraksts_karte_width', w);
  }

  mapPaneSizeChangeHor = (h) => {
    this.props.guiSet('dzerama_udens_sateces_baseini_saraksts_karte_height', h);
  }

  handleOnSelect = (row, isSelect) => {
    this.props.dzeramaUdensSatecesBaseinsSelected({ id: row.id, isSelect })
  }

  render() {
    const { dzeramaUdensSatecesBaseins, gui, riskaObjektuKategorijas } = this.props
    const { selectedItem } = dzeramaUdensSatecesBaseins
    const { list: riskaObjektuKategorijasList } = riskaObjektuKategorijas
    // loading while we have no dzeramaUdensSatecesBaseins
    if (!selectedItem) {
      return (<Loading />)
    }

    const vectorLayerCfgPamatinfo = getVectorLayerCfgPamatinfo(selectedItem)
    const vectorLayerCfgAktualaSituacija = getVectorLayerCfgAktualaSituacija(selectedItem, this.props.dzur_aktuala_situacija, riskaObjektuKategorijasList)

    const {
      query, getTabCfgsFunc, addUrlQuery
    } = this.props

    const isNew = !!(selectedItem && (!selectedItem.id || selectedItem.id === 'jauns'))
    const activeTab = query && query.tab && !isNew ? query.tab : 'pamatinfo'

    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
    const largeScreen = vw > 900

    if (activeTab === 'kopsavilkums') {
      return (
        <div className="pane-paddings-hor">
          <BaseinsTabs activeTab={activeTab} isNew={isNew} getTabCfgsFunc={getTabCfgsFunc} addUrlQuery={addUrlQuery} selectedItem={selectedItem} />
        </div>
      )
    }

    return (<>
      <SplitterLayout
        key={largeScreen ? 'hor' : 'ver'}
        vertical={!largeScreen}
        customClassName="pane-paddings-hor"
        percentage
        primaryIndex={0}
        secondaryInitialSize={largeScreen ? gui.dzerama_udens_sateces_baseini_saraksts_karte_width : gui.dzerama_udens_sateces_baseini_saraksts_karte_height}
        onSecondaryPaneSizeChange={largeScreen ? this.mapPaneSizeChange : this.mapPaneSizeChangeHor}
      >
        <div className="leftside">
          <BaseinsTabs activeTab={activeTab} isNew={isNew} getTabCfgsFunc={getTabCfgsFunc} addUrlQuery={addUrlQuery} selectedItem={selectedItem} />
        </div>

        {activeTab === 'aktuala_situacija' || activeTab === 'riska_novertejums' ?
          <div className="rightside">
            <div className="karte-wrapper">
              <IzraktenisMap key={selectedItem.id} mapId="dzerama_udens_sateces_baseins_kartina" vectorLayerCfgs={vectorLayerCfgAktualaSituacija} />
            </div>
          </div>
          :
          <div className="rightside">
            <div className="karte-wrapper">
              <IzraktenisMap key={selectedItem.id} mapId="dzerama_udens_sateces_baseins_kartina" vectorLayerCfgs={vectorLayerCfgPamatinfo} />
            </div>
          </div>
        }
      </SplitterLayout>
    </>

    )
  }
}

const mapStateToProps = ({ dzeramaUdensSatecesBaseins, dzur_aktuala_situacija, gui, location, riskaObjektuKategorijas }) => ({ dzeramaUdensSatecesBaseins, dzur_aktuala_situacija, gui, query: location.query, riskaObjektuKategorijas })

const DzeramaUdensSatecesBaseinsKartina = connect(mapStateToProps, { ...dzeramaUdensSatecesBaseinsActions, guiSet, addUrlQuery })(BaseinsKartina)

export default DzeramaUdensSatecesBaseinsKartina
